var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[_c('admin-nav',{staticClass:"openNav"}),_c('div',{staticClass:"contentContainer h-100 openNavContent"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }